import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as SupplierService from '../../services/supplierService';
import { SUPPLIER_STATUS } from '../../constants/Constants';

export const fetchSuppliers = createAsyncThunk('suppliers/fetch', async (_, { rejectWithValue }) => {
  try {
    const data = await SupplierService.fetchSuppliers();
    return data;
  } catch (error) {
    return rejectWithValue(error.message);
  }
});

export const submitSupplierData = createAsyncThunk(
  'suppliers/submit',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await SupplierService.submitSupplierData(formData);
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const supplierFormSlice = createSlice({
  name: 'suppliers',
  initialState: {
    contactDetails: [],
    associatedSuppliers: [],
    supplierInfo: {
      companyName: '',
      addressLine1: '',
      addressLine2: '',
      state: '',
      country: '',
      zipcode: '',
    },
    status: SUPPLIER_STATUS.IDLE,  
    error: null,
  },
  reducers: {
    updateContactDetails: (state, action) => {
      state.contactDetails = action.payload;
    },
    updateAssociatedSuppliers: (state, action) => {
      state.associatedSuppliers = action.payload;
    },
    updateSupplierInfo: (state, action) => {
      state.supplierInfo = { ...state.supplierInfo, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSuppliers.pending, (state) => {
        state.status = SUPPLIER_STATUS.LOADING; 
      })
      .addCase(fetchSuppliers.fulfilled, (state, action) => {
        state.status = SUPPLIER_STATUS.SUCCEEDED; 
        const data = action.payload;
        state.contactDetails = (data[0]?.contactDetails || []).map(contact => ({
          firstName: contact.firstName || '',
          lastName: contact.lastName || '',
          email: contact.email || '',
          phoneNumber: contact.phoneNumber || '',
          userType: contact.userType || '',
          designation: contact.designation || ''
        }));
        state.associatedSuppliers = (data[0]?.associatedSuppliers || []).map(associatedSupplier=>({
          supplierId: associatedSupplier.supplierId||'',
          countryCode: associatedSupplier.countryCode||''


        }));
        state.supplierInfo = {
          companyName: data[0].companyName || '',
          addressLine1: data[0].addressLine1 || '',
          addressLine2: data[0].addressLine2 || '',
          state: data[0].state || '',
          country: data[0].country || '',
          zipcode: data[0].zipcode || ''
        };
      })
      .addCase(fetchSuppliers.rejected, (state, action) => {
        state.status = SUPPLIER_STATUS.FAILED;  
        state.error = action.payload;
      })
      .addCase(submitSupplierData.pending, (state) => {
        state.status = SUPPLIER_STATUS.LOADING; 
      })
      .addCase(submitSupplierData.fulfilled, (state, action) => {
        state.status = SUPPLIER_STATUS.SUCCEEDED; 
      })
      .addCase(submitSupplierData.rejected, (state, action) => {
        state.status = SUPPLIER_STATUS.FAILED;  
        state.error = action.payload;
      });
  }
});

export const { updateContactDetails, updateAssociatedSuppliers, updateSupplierInfo } = supplierFormSlice.actions;

export default supplierFormSlice.reducer;
